import styles from './basic-support.module.scss';
import { AvatarOnlyBorderSecondary, Card, CardContent, CardHeader, Divider, Icon, Link, Tooltip, Typography } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { ICustomerSupportContracts } from '../../_models/customer-support-contracts';
import { getPlainDate } from '../../helpers';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface BasicSupportProps {
  selectedContract: ICustomerSupportContracts,
  onNextUserClick: () => void,
  numberOfContracts: number,
  selectedContractIndex: number
}

export function BasicSupport(props: BasicSupportProps) {
  const { t } = useTranslation();
  let agreementType = props.selectedContract.isGroupDeal ? t('basicSupport.groupDeal') : t('basicSupport.individualDeal');
  switch (props.selectedContract.supportType) {
    case 'FO-DAK-12-K-Inc':
      agreementType = t('basicSupport.includedForGroup');
      break;
    case 'FO-DAK-12-Inc':
      agreementType = t('basicSupport.includedInSubscription');
      break;
  }
  
  return (
    <Row className='mb-4'>
      <Col md={6} xxl={3}>
        <Card className='mb-4'>
          <CardHeader
            avatar={
              <AvatarOnlyBorderSecondary>
                <Icon>numbers</Icon>
              </AvatarOnlyBorderSecondary>
            }
            title={t('standard.contract')}
          />
          <CardContent className='pt-0' sx={{ minHeight: 65 }}>
            <div className="d-flex">
              <div>
                <Typography
                  component="div"
                  className='MuiTypography-body6'>
                  {t('basicSupport.contractNumber')}
                </Typography>
                <Typography
                  component="div"
                  className='MuiTypography-body5'>
                  {props.selectedContract.contractNumber}
                </Typography>
              </div>
              {props.numberOfContracts !== 1 ?
                <>
                  <Divider orientation="vertical" variant="fullWidth" flexItem className="mx-4" />
                  <div>
                    <Typography
                      component="div"
                      className='MuiTypography-body5 me-2'>
                      {props.selectedContractIndex} av {props.numberOfContracts}
                    </Typography>
                    <Link
                      component={'span'}
                      underline='always'
                      onClick={props.onNextUserClick}
                      className='d-flex align-items-center MuiTypography-body5'>
                      {t('basicSupport.seeNext')} <Icon className="material-icons-outlined">navigate_next</Icon>
                    </Link>
                  </div>
                </> : null
              }
            </div>
          </CardContent>
        </Card>
      </Col>
      <Col md={6} xxl={3}>
        <Card className='mb-4'>
          <CardHeader
            avatar={
              <AvatarOnlyBorderSecondary>
                <Icon>person</Icon>
              </AvatarOnlyBorderSecondary>
            }
            title={t('standard.contractManager')}
          />
          <CardContent className='pt-0' sx={{ minHeight: 65 }}>
          {props.selectedContract.contractManager.personName}
          </CardContent>
        </Card>
      </Col>
      <Col md={6} xxl={3}>
        <Card className='mb-4'>
          <CardHeader
            avatar={
              <AvatarOnlyBorderSecondary>
                <Icon>handshake</Icon>
              </AvatarOnlyBorderSecondary>
            }
            title={t('basicSupport.agreementType')}
          />
          <CardContent className='pt-0' sx={{ minHeight: 65 }}>
            <Typography
              className='MuiTypography-body5'
              component={'div'}>
              {agreementType}
            </Typography>
            <Typography
              className='MuiTypography-body5'
              component="div">
              {props.selectedContract.isGroupDeal ? t('basicSupport.noRestrictions') : props.selectedContract.numberOfUsers + t('basicSupport.users')}
            </Typography>
          </CardContent>
        </Card>
      </Col>
      <Col md={6} xxl={3}>
        <Card className='mb-4'>
          <CardHeader
            avatar={
              <AvatarOnlyBorderSecondary>
                <Icon>event</Icon>
              </AvatarOnlyBorderSecondary>
            }
            title={t('basicSupport.nextInvoice')}
          />
          <CardContent className='pt-0' sx={{ minHeight: 65 }}>
            {props.selectedContract.isActive ?
              <>
                <Typography
                  component="div"
                  className='MuiTypography-body6'>
                  {t('standard.date')}
                </Typography>
                <Typography
                  component="div"
                  className='MuiTypography-body5'>
                  {getPlainDate(props.selectedContract.contractInfo.nextInvoicingDate, t)}
                </Typography>
              </> :
              <Typography
                className='MuiTypography-body5'
                component="div">
                {t('standard.terminated')}
              </Typography>
            }
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
}

export default BasicSupport;